import { render, staticRenderFns } from "./BillParameterHistory.vue?vue&type=template&id=5afdebd0&scoped=true"
import script from "./BillParameterHistory.vue?vue&type=script&lang=js"
export * from "./BillParameterHistory.vue?vue&type=script&lang=js"
import style0 from "./BillParameterHistory.vue?vue&type=style&index=0&id=5afdebd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afdebd0",
  null
  
)

export default component.exports